import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import { RoadFeaturesWithBruksklasse, SpesialTransportVeggruppe } from "../../services/RuteplanAPI";


export function SpesialTransportVeggruppeItem(props: IRoutePartProps) {
    const roadFeatures = props.roadFeatures as RoadFeaturesWithBruksklasse;
    
    return (
        <>
            {roadFeatures && roadFeatures.spesialTransportVeggrupper && roadFeatures.spesialTransportVeggrupper.length > 0 &&
            <List>         
                {roadFeatures.spesialTransportVeggrupper.map( (veggruppe: SpesialTransportVeggruppe, index: number) => {
                    return (
                        <ListItem 
                        key={`${veggruppe.veggruppe} - ${index}`} 
                        className="roadFeature"
                        onClick={(event) => {props.onClick(veggruppe, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(veggruppe)}
                        onMouseLeave={props.onMouseLeaveItem}>
                            Veggruppe: {veggruppe.veggruppe}                            
                        </ListItem>
                    )
                })}
            </List>
            }
        </>
    )
}